<script>
  import Icon from "@iconify/svelte";

  let { message = "", icon = "mdi:inbox-outline", children } = $props();
</script>

<div class="text-center py-12">
  <Icon icon={icon} class="mx-auto h-12 w-12 text-zinc-600" />
  <p class="mt-4 text-zinc-500">{message}</p>
  {#if children}
    <div class="mt-4">
      {@render children()}
    </div>
  {/if}
</div>
